import { BankAccountsContext } from '@app/collections/fortress/BankAccountsContext'
import { Button, Card, Col, List, ListItem, Radio, Row, Text, useForm } from '@app/components'
import { PlusOutlined } from '@app/components/icons'
import { AddNewCardDrawer } from '@app/generic-collections'
import { IStore } from '@app/redux'
import axios from 'axios'
import React, { useContext, useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'

declare global {
  interface Window {
    FortressElementsJS: any
  }
}
export const CardTransferContent: React.FC<any> = ({ fund, setFund }) => {
  const [addNewCardDrawerOpen, setAddNewCardDrawerOpen] = useState(false)
  const { cardAccounts, fetchAccounts } = useContext(BankAccountsContext)
  const { user } = useSelector((state: IStore) => state)

  const [form] = useForm()

  useEffect(() => {
    fetchAccounts()
  }, [])

  const generateElementSessionJWT = async (identityId: string) => {
    const params = { identityId, elementName: 'cardLinking' }
    const { data } = await axios.get('/api/fortress/jwt', { params })
    return data
  }

  const ElementKYC = useMemo(() => {
    if (!window.FortressElementsJS) return null
    const EJS = window.FortressElementsJS
    return EJS.createElementClient({
      elementName: EJS.ElementNames.CARD,
      onMessage: async (message: any) => {
        if (message?.type == 'ELEMENT_UPDATED') {
          if (message.payload.status == 'success' && message?.payload?.card != null) {
            await fetchAccounts()
          }
        }
      },
      theme: { primaryColor: '#2D54A4', secondaryColor: '#F6F6F6' },
      uiLabels: {
        statusScreenButton: 'Continue',
      },
    })
  }, [fetchAccounts])

  useEffect(() => {
    if (!ElementKYC) return
    ElementKYC.done(({ status }) => {
      // eslint-disable-next-line no-console
      console.log(`Element result status: ${status}`)
    })
    return () => {
      ElementKYC.destroy()
    }
  }, [ElementKYC])

  if (!ElementKYC) {
    // eslint-disable-next-line no-console
    console.log('FortressElementsJS not available')
    return null
  }

  // Button click handler
  const handleButtonClick = async () => {
    const { jwt } = await generateElementSessionJWT(user.fortressIdentityId)
    try {
      ElementKYC.run(jwt)
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log('Erorr loading element', e)
    }
  }

  const toggleAddNewCardDrawerOpen = () => {
    setAddNewCardDrawerOpen(!addNewCardDrawerOpen)
  }

  return (
    <>
      <Row gutter={[10, 10]}>
        <Col span={24}>
          <Text>Saved cards</Text>
          <List
            itemLayout="horizontal"
            dataSource={cardAccounts}
            renderItem={(item) => (
              <ListItem style={{ paddingLeft: 0, paddingRight: 0 }}>
                <Card style={{ width: '100%' }}>
                  <Row>
                    <Col style={{ justifyContent: 'center', display: 'flex' }}>
                      <Radio checked={fund === item.id} onChange={() => setFund(item.id)} />
                    </Col>
                    <Col>
                      <Row gutter={[15, 15]}>
                        <Col>{item.icon}</Col>
                        <Col>
                          <Row>
                            <Col>
                              <Text>Card #: **** **** **** {item['accountNumberLast4']}</Text>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <Text>Issuer: {item['network']}</Text>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <Text>Cardholder: {item['nameObfuscated']}</Text>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Card>
              </ListItem>
            )}
          />
        </Col>

        <Col>
          <Button icon={<PlusOutlined />} onClick={handleButtonClick}>
            Add new card
          </Button>
        </Col>
      </Row>
      <AddNewCardDrawer
        open={addNewCardDrawerOpen}
        toggleOpen={toggleAddNewCardDrawerOpen}
        form={form}
        refresh={fetchAccounts}
      />

      <div id="element-container" />
    </>
  )
}
